import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        avatar: {
            backgroundColor: theme.palette.primary.main,
            width: 32,
            height: 32,
            fontSize: 14,
        },
        active: {
            color: theme.palette.primary.main,
            '& .MuiListItem-button': {
                backgroundColor: theme.palette.primary.light,
            },
        },
        inActive: {
            color: theme.palette.text.primary,
        },
        list: {
            padding: 0,
        },
        listIcon: {
            padding: 5,
            paddingTop: 10,
            paddingBottom: 10,
            paddingRight: 28,
        },
    }),
);
